import { render, staticRenderFns } from "./PenaltiesListPage.vue?vue&type=template&id=3e8a3c99&"
import script from "./PenaltiesListPage.vue?vue&type=script&lang=js&"
export * from "./PenaltiesListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports